import {EparcoursPath} from '../../../constantes/menu/menu-items/eparcours-path';

export class LoginNavigator {
  constructor(private router) {}

  navigate(returnUrl: string = this.router.url, autoLogout: boolean = false) {
    this.router.navigate([`/${EparcoursPath.root.LOGIN}`], {
      queryParams: {
        returnUrl: returnUrl,
        autoLogout: autoLogout,
      },
    });
  }
}
